import React from "react";
import "./BacklogCount";
import BacklogCount from "./BacklogCount";

export function getSelectedYr(){

    let selectedYr;
    let selected = document.querySelector('input[type="radio"]:checked');
    if (selected){
         selectedYr= selected.value;
    }
    return (
        console.log('total sem: '+selectedYr*2)
    );
}
export function getBacklogStatus(){
    let hasBacklog;
    let selected = document.querySelector('input[type="radio"]:checked');
    if(selected){
        hasBacklog=selected.value;
    }
}

